import { useAuthStore } from "@/stores/auth-store"

let sessionExpired = false

/**
 * Called once when the session is definitively dead (refresh failed, no refresh
 * token, or a stray 401 surfaced to a query). Clears auth state and hard-redirects
 * to the login screen. The full reload instantly kills every in-flight fetch and
 * all React state, so there is no error-boundary flash and no doomed follow-up work.
 */
export function expireSession() {
  if (sessionExpired) return
  sessionExpired = true
  useAuthStore.getState().logout()
  window.location.assign("/login")
}

/**
 * True only for 401. 403 is intentionally excluded: a 403 can be a legitimate
 * permission denial for a valid session, and in the idle-expiry case the many
 * concurrent 401s already trigger expiry (the redirect then cancels the 403 query).
 */
export function isAuthError(error: unknown): boolean {
  if (error && typeof error === "object" && "response" in error) {
    const status = (error as { response?: Response }).response?.status
    return status === 401
  }
  return false
}
